function rollingCharacter(): void {
  const donutIcon = document.getElementById("donut-icon") as HTMLElement;
  if (!donutIcon) return;

  // howToOrderセクションを取得
  const howToOrderSection = document.querySelector(".p-how-to-order") as HTMLElement;
  if (!howToOrderSection) return;

  // Animation parameters
  const duration = 4500; // 4.5 seconds
  const pauseDuration = 100; // 100ms pause at each end

  // 画面幅に基づいて移動距離を計算（1440pxのときに200pxが最大）
  const calculateDistance = (): number => {
    const maxDistance = 200;
    const referenceWidth = 1440;
    const currentWidth = window.innerWidth;
    return Math.min(maxDistance, (currentWidth / referenceWidth) * maxDistance);
  };

  // 初期の移動距離を設定
  let distance = calculateDistance();

  // 開始位置はdistanceの半分のマイナス値に設定（中央を起点に左右に動く）
  let startX = -distance / 2;
  let endX = distance / 2;

  // 初期表示用のアニメーションパラメータ
  const initialStartX = -window.innerWidth / 2; // 画面外左から
  const entranceDuration = 3000; // 3秒かけて初期位置に移動

  // 初期状態：画面外に配置（非表示）
  donutIcon.style.opacity = "0";
  donutIcon.style.transform = `translateX(${initialStartX}px) rotate(0deg)`;

  // リサイズ時に移動距離を再計算
  window.addEventListener("resize", () => {
    distance = calculateDistance();
    startX = -distance / 2;
    endX = distance / 2;
  });

  // Intersection Observerの設定
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 一度だけ実行するため、監視を解除
          observer.unobserve(howToOrderSection);

          // 要素を表示
          donutIcon.style.opacity = "1";

          // 初期アニメーション：画面外から初期位置へ（ゴロゴロしながら）
          animateEntranceWithRolling().then(() => {
            // 初期アニメーション完了後、通常のアニメーションを開始
            animate();
          });
        }
      });
    },
    {
      threshold: 0.3, // 30%表示されたらトリガー
    },
  );

  // 要素の監視を開始
  observer.observe(howToOrderSection);

  // Custom easing function for slow start
  function easeInOutCustom(t: number): number {
    // Similar to the [0.22, 0.03, 0.55, 1] cubic bezier
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  // ゴロゴロしながら初期位置に移動するアニメーション関数
  function animateEntranceWithRolling(): Promise<void> {
    return new Promise((resolve) => {
      const startTime = performance.now();
      const totalRotations = 2; // 入場時に何回転するか

      function step(currentTime: number) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / entranceDuration, 1);
        const easedProgress = easeInOutCustom(progress);

        const currentX = initialStartX + (startX - initialStartX) * easedProgress;
        // 進行に合わせて回転（初期位置に着いたときに360度の倍数になるようにする）
        const currentRotation = easedProgress * totalRotations * 360;

        donutIcon.style.transform = `translateX(${currentX}px) rotate(${currentRotation}deg)`;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          resolve();
        }
      }

      requestAnimationFrame(step);
    });
  }

  // Animation function
  async function animate() {
    while (true) {
      // 現在の移動距離を取得（リサイズの影響を反映するため）
      const currentStartX = -calculateDistance() / 2;
      const currentEndX = calculateDistance() / 2;

      // Roll to the right
      await animateRoll(currentStartX, currentEndX, 0, 360);

      // Pause at the right end
      await new Promise((resolve) => setTimeout(resolve, pauseDuration));

      // Roll to the left
      await animateRoll(currentEndX, currentStartX, 360, 0);

      // Pause at the left end
      await new Promise((resolve) => setTimeout(resolve, pauseDuration));
    }
  }

  // Function to animate the roll from start to end position
  function animateRoll(startX: number, endX: number, startRotation: number, endRotation: number): Promise<void> {
    return new Promise((resolve) => {
      const startTime = performance.now();

      function step(currentTime: number) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeInOutCustom(progress);

        const currentX = startX + (endX - startX) * easedProgress;
        const currentRotation = startRotation + (endRotation - startRotation) * easedProgress;

        donutIcon.style.transform = `translateX(${currentX}px) rotate(${currentRotation}deg)`;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          resolve();
        }
      }

      requestAnimationFrame(step);
    });
  }
}

export { rollingCharacter };
